import { initialCarpoolState, initialIsCarpoolErrorState } from './carpool';
import { vehicleDetailInitialErrorState, formInitialState, infoBadgeStateInitialState, resetVehicleDetailState, registeredVehicleDataItem, emailInitialState, userInitialState, chaufferIntialState, } from './vehicleDetail';
export var vehicleRegistrationInitialState = {
    initialRegisterVehicleState: registeredVehicleDataItem[0],
    vehicleDetailInitialErrorState: vehicleDetailInitialErrorState,
    initialFormState: formInitialState,
    initialInfoBadgeResponseState: infoBadgeStateInitialState,
    resetVehicleState: resetVehicleDetailState,
    initialvehicleRegistrationState: registeredVehicleDataItem,
    initialEmailState: emailInitialState,
    intialUserState: userInitialState,
    initialChaufferState: chaufferIntialState,
};
export var carpoolInitialState = {
    initialCarpoolState: initialCarpoolState,
    initialIsCarpoolErrorState: initialIsCarpoolErrorState,
};
export var environmentInitialState = {
    environment: '',
};
export var configInitialState = {};
export var regionInitialState = {
    regionId: '',
    regionName: '',
    policyCheckLink: '',
    carpoolPolicyLink: '',
    faqLink: '',
    showV2UI: false,
    showMyHubAwareness: false,
    carpoolEnabled: false,
    enabled: false,
    registrationTypeList: '',
    vehicleTypeList: '',
    fuelTypeList: '',
};
